'use client'

import useShoppingCart from '@dustin-web/product-components/src/hooks/dataloader/use-shopping-cart'
import { EmptyCart } from './empty-cart/empty-cart'

const CartPageWrapper = ({ children }: { children: React.ReactNode }) => {
  const { cartItems } = useShoppingCart({
    withRequiredEndUserInformation: false,
  })

  if (cartItems.length === 0) {
    return <EmptyCart />
  }

  return children
}

export default CartPageWrapper
